export const INTERNAL_EMAIL_DOMAIN = '@reebelo.com';

export const isInternalUser = (email?: string | null): boolean =>
  (email ?? '').trim().toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN);
